import styled from 'styled-components'

const Related = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    text-align: center;
    align-content: center;
    width: 70%;
    margin: auto;
    @media (max-width: 768px) {
      width: 90%;
      margin: auto;
    }
    .related-title {
      flex-basis: 100%;
      font-size: 2rem;
    }
    .related-bike-container
    {
      border: 6px solid #DFE1E2;
      padding: 40px;
      margin: 20px 20px 70px 20px;
      width: 200px;
      @media (max-width: 768px) {
      margin: 20px 20px 10px 20px;
      }
    }
    p {
      font-size: 1.2rem;
      font-weight: 600;
      margin-bottom: 30px;
      height: 30px;
    }
    h2 {
      margin-bottom: 10px;
    }
    img {
      width: 200px;
    }
    button {
      background-color: #dfe1e2;
      color: #1a1c1d;
      border-radius: 5px;
      text-decoration: none;
      font-weight: 700;
      cursor: pointer;
      font-size: 0.9rem;
      margin-top: 20px;
    }
    button:hover {
      background-color: #EAECEC;
    }
    .img-container {
      height: 210px;
    }
    .bike3 {
      width: 80%
    }
  
`
export default Related;